export const REACTION_EMOJIS = ['👍', '🔥', '🙏', '😢', '😁', '❤️', '😱'];

export const TYPING_TTL_MS = 3000;
export const TYPING_MIN_INTERVAL_MS = 2000;

export const reactionIsMine = (reaction, selfParticipantId) =>
    (reaction?.participantIds || []).some((id) => String(id) === String(selfParticipantId));
